/*! Twire stripe - MIT license  */
export default {

	amount:					null,
	stripe:					null,
	elements:				null,
	$form:					null,
	cardErrors:				{},
	locale:					'en',
	apiVersion:				'2024-06-20',
	generalError:			'An error occurred processing the payment',
	serverError:			'A server error occurred; please contact us to check your payment status',
	onGeneralError:			($form, message) => { alert(message); },
	onServerError:			($form, message) => { alert(message); },
	onPaymentStart:			($form) => {},
	onSuccess:				($form, paymentIntent, mode) => {},
	paymentMethodElement:	null,
	returnURL:				null,
	cardClassNames: {

		number: 'card-number',
		expiry: 'card-expiry',
		cvc:	'card-cvc'

	},
	cardBillingFormNames: {

		name:   'name',
		email:  'email',
		phone:  'phone',

		address: {

			line1:	  'address-line-1',
			line2:	  'address-line-2',
			town:	   'town',
			county:	 'county',
			postcode:   'postcode',
			country:	'country'

		}
	},
	initCardElements: function($form, apiKey, elementsConfig, style) {

		var _self		   	= this;
		_self.$form		 	= $form;
		_self.cardErrors	= require('../json/twire.stripe-card-errors-' + _self.locale + '.json');
		_self.stripe		= Stripe(apiKey, {

			apiVersion: _self.apiVersion,
			locale: _self.locale
			
		});

		_self.elements			  = _self.stripe.elements(elementsConfig);
		_self.paymentMethodElement  = _self.elements.create('cardNumber', { style: style });

		_self.paymentMethodElement.mount('.' + _self.cardClassNames.number);

		_self.elements.create('cardExpiry', { style: style }).mount('.' + _self.cardClassNames.expiry);
		_self.elements.create('cardCvc',	{ style: style }).mount('.' + _self.cardClassNames.cvc);

	},

	processNewCardPayment: function(path, metaData = [], customer = '', save = false) {

		var _self   = this;
		_self.path  = path;

		_self.onPaymentStart(_self.$form);

		fetch(_self.path, {

			method: 'POST',
			headers: {

				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

			},
			body: (() => {

				const formData = new URLSearchParams(new FormData(_self.$form[0]));

				formData.append('twire', JSON.stringify({

					email:	  	_self.$form[0].querySelector('[name="' + _self.cardBillingFormNames.email + '"]').value,
					amount:	 	_self.amount,
					metaData:   metaData,
					customer:   customer,
					save:	  	save ? 1 : 0
					
				}));

				return formData.toString();

			})()

		}).then(function(response) {

			if (!response.ok) {

				throw response;

			}

			return response.json();

		}).then(function(response) {
			
			if (response.data && response.data == 'custom-message') {

				_self.onGeneralError(_self.$form, response.message);

				return;

			}

			var confirmMethod = (response.data.mode === 'setup') ? 'confirmCardSetup' : 'confirmCardPayment';

			_self.stripe[confirmMethod](response.data.client_secret, {

				payment_method: {

					card: _self.paymentMethodElement,
					billing_details: {

						name:  _self.$form.find('[name="' + _self.cardBillingFormNames.name  + '"]').val(),
						email: _self.$form.find('[name="' + _self.cardBillingFormNames.email + '"]').val(),
						phone: _self.$form.find('[name="' + _self.cardBillingFormNames.phone + '"]').val(),

						address: {

							line1:			_self.$form.find('[name="' + _self.cardBillingFormNames.address.line1   + '"]').val(),
							line2:			_self.$form.find('[name="' + _self.cardBillingFormNames.address.line2   + '"]').val(),
							city:		 	_self.$form.find('[name="' + _self.cardBillingFormNames.address.town  + '"]').val(),
							state:			_self.$form.find('[name="' + _self.cardBillingFormNames.address.county   + '"]').val(),
							postal_code:	_self.$form.find('[name="' + _self.cardBillingFormNames.address.postcode + '"]').val(),
							country:		_self.$form.find('[name="' + _self.cardBillingFormNames.address.country  + '"]').val()

						}
					}
				},
				return_url: _self.returnURL

			}, { 

				redirect: 'if_required'

			}).then(function(result) {

				if (result.error) {

					_self.onGeneralError(_self.$form, _self.getError(result.error.code));

				} else {
					
					var intent = (response.data.mode === 'setup') ? result.setupIntent : result.paymentIntent;

					if (intent && intent.status == 'succeeded') {

						_self.onSuccess(_self.$form, intent.id, response.data.mode);

					}
				}

			});

		}).catch(function(error) {

			_self.handleFail(error);

		});

	},

	handleFail: function(jqXHR) {

		var _self = this;

		if (jqXHR.responseJSON && jqXHR.responseJSON.data && jqXHR.responseJSON.data == 'custom-message') {

			_self.onServerError(_self.$form, jqXHR.responseJSON.message);

		} else {

			_self.onServerError(_self.$form, _self.serverError);

		}
	},

	getError: function(code) {

		var _self = this;

		return _self.cardErrors[code] || _self.generalError;

	},

	/*
	 * Example for paying with a saved card (on-Session):
	 * _self.processSavedCardPayment('/pay-endpoint/', { customer: 'cus_123', paymentMethod: 'pm_456', amount: 2000 }, successCb, errorCb);
	 * 
	 * Example for confirming existing intent (off-session recovery):
	 * _self.processSavedCardPayment(null, { clientSecret: 'pi_abc_secret_xyz' }, successCb, errorCb);
	 */
	processSavedCardPayment: function(apiKey, url, data, onSuccess, onError) {

		var _self = this;

		_self.stripe = Stripe(apiKey, {

			apiVersion: _self.apiVersion,
			locale: _self.locale
			
		});

		// Internal helper to trigger the Stripe 3D Secure modal.
		// Used for both live payments and email recovery links.
		const confirm = (secret) => {

			_self.stripe.confirmCardPayment(secret).then((result) => {

				if (result.error) {

					onError(_self.getError(result.error.code));

				} else if (result.paymentIntent && (result.paymentIntent.status === 'succeeded' || result.paymentIntent.status === 'processing')) {

					onSuccess(result.paymentIntent.id);

				}

			});

		};

		// CASE: Off-session recovery (e.g. email link)
		// If client_secret is present in data, the intent already exists
		// We skip the server POST and jump straight to the 3DS challenge
		if (data && data.clientSecret) {

			confirm(data.clientSecret);

			return;

		}

		// CASE: on-session "one-click" payment
		// No secret exists, so we POST to the server to create the PaymentIntent
		fetch(url, {

			method: 'POST',
			headers: {

				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest'

			},
			body: JSON.stringify(data)
		})
		.then(response => {

			if (!response.ok) throw new Error(_self.serverError);

			return response.json();

		})
		.then(response => {

			if (response.error) {

				onError(_self.getError(response.error.code));

				return;

			}

			// Instant success if no 3DS is required by the bank
			if (response.status == 'succeeded' || response.status === 'processing') {

				onSuccess(response.id, response.mode);

				return;

			}

			// Success with challenge (3DS is required)
			if (response.client_secret) {

				confirm(response.client_secret);

			} else {

				onError(_self.generalError);
			}

		})
		.catch(error => {

			onError(error.message || _self.serverError);

		});

	}

};